var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
define(["require", "exports", "hypo_elements/Containers/Reitermodul/Reitermodul", "hypo_bvo/Drklein/Shared/AgentService", "hypo_bvo/Drklein/ProfilKontaktformular/ProfilKontaktformular", "jquery"], function (require, exports, Reitermodul, AgentService, ProfilKontaktformular) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    Reitermodul = __importStar(Reitermodul);
    AgentService = __importStar(AgentService);
    ProfilKontaktformular = __importStar(ProfilKontaktformular);
    //OVIT-9179: Don't open the first tab on phone and tablet
    /*$(() => {
        if (MobileDetection.isMobile() || MobileDetection.isTablet()) {
            Reitermodul.openTabByName("#profil-tab-ueber-mich");
        }
    });*/
    function generateBeratungsleistungText(produktspartennamen) {
        var beratungsleistungText = "Gern berate ich Sie";
        if (produktspartennamen.length === 1) {
            beratungsleistungText += " im Bereich ".concat(produktspartennamen[0]);
        }
        if (produktspartennamen.length > 1) {
            beratungsleistungText += generateBeratungsleistungTextForMultipleProduktsparten(produktspartennamen);
        }
        return "".concat(beratungsleistungText, ".");
    }
    function generateBeratungsleistungTextForMultipleProduktsparten(produktspartennamen) {
        var beratungsleistungText = " in den Bereichen ";
        var numberOfProduktsparten = produktspartennamen.length;
        var indexOfLastProduktsparte = numberOfProduktsparten - 1;
        var numberOfNonCommaSeparatedProduktsparten = 2;
        for (var i = 0; i <= indexOfLastProduktsparte - numberOfNonCommaSeparatedProduktsparten; i++) {
            beratungsleistungText = beratungsleistungText + produktspartennamen[i] + ", ";
        }
        beratungsleistungText = beratungsleistungText
            + produktspartennamen[indexOfLastProduktsparte - 1]
            + " und "
            + produktspartennamen[indexOfLastProduktsparte];
        return beratungsleistungText;
    }
    AgentService.getAgent($(".profilInformation").data("uid")).done(function (agent) {
        $(function () {
            var $profilUebermich = $(".profilUebermich");
            var $beratungsleistungText = $profilUebermich.find(".profilUebermich_beratungsleistungenText");
            var $profilInformation = $(".profilInformation");
            $beratungsleistungText.text(generateBeratungsleistungText(agent.productGroups.map(function (pg) { return pg.name; })));
            $profilInformation.find(".produktsparte").each(function (index, element) {
                var $produktsparte = $(element);
                $produktsparte.find(".callToAction_button").on("click", function (event) {
                    Reitermodul.openTabByNameFromExternalTrigger("#profil-tab-kontaktformular");
                    ProfilKontaktformular.showKontaktformular($produktsparte.data("produktsparte"));
                    window.location.href = "#kontaktformularChoice_profil-information";
                    event.preventDefault();
                });
            });
        });
    });
});
